import React, { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { isTaskOverdue } from "../utils/taskHelpers";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { toLocalDateStr } from "../utils/dateUtils";

export default function ProjectTimeline({ project, onSelectTask }) {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (!project?.organizationId) return; // aperta solo per id: aspetto i dati
    const q = query(collection(db, "tasks"), where("projectId", "==", project.id), where("organizationId","==",project.organizationId));
    return onSnapshot(q, snap => {
      const t = snap.docs.map(d => ({ id: d.id, ...d.data() }))
        .filter(t => t.dueDate)
        .sort((a, b) => a.dueDate.localeCompare(b.dueDate));
      setTasks(t);
    });
  }, [project.id, project.organizationId]);

  const today = toLocalDateStr(new Date());

  // Raggruppa per mese
  const byMonth = {};
  tasks.forEach(t => {
    const month = t.dueDate.substring(0, 7);
    if (!byMonth[month]) byMonth[month] = [];
    byMonth[month].push(t);
  });

  const priorityColor = { alta: "#dc2626", media: "#d97706", bassa: "#059669" };
  const statusColor = { aperta: "#2563eb", in_corso: "#d97706", completata: "#059669", annullata: "#9ca3af" };

  return (
    <div className="content-scroll" style={{ padding: "20px 32px" }}>
      <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 20, color: "#374151" }}>
        Cronologia attività — {tasks.length} con scadenza
      </h3>

      {Object.keys(byMonth).length === 0 ? (
        <div className="empty-state">
          <p>Nessuna attività con scadenza impostata</p>
        </div>
      ) : Object.keys(byMonth).sort().map(month => {
        const date = parseISO(month + "-01");
        return (
          <div key={month} style={{ marginBottom: 32 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#7c3aed", marginBottom: 14, display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#7c3aed" }}/>
              {format(date, "MMMM yyyy", { locale: it })}
            </div>
            <div style={{ borderLeft: "2px solid #e5e7eb", marginLeft: 5, paddingLeft: 24 }}>
              {byMonth[month].map((task, i) => {
                const isOverdue = isTaskOverdue(task);
                return (
                  <div key={task.id} style={{ position: "relative", marginBottom: 12 }}>
                    {/* Dot */}
                    <div style={{ position: "absolute", left: -30, top: 12, width: 10, height: 10, borderRadius: "50%", background: isOverdue ? "#dc2626" : priorityColor[task.priority] || "#7c3aed", border: "2px solid #fff", boxShadow: "0 0 0 2px " + (isOverdue ? "#dc2626" : priorityColor[task.priority] || "#7c3aed") }}/>
                    <div onClick={() => onSelectTask(task)}
                      style={{ background: "#fff", border: `1px solid ${isOverdue ? "#fecaca" : "#e5e7eb"}`, borderRadius: 8, padding: "10px 14px", cursor: "pointer", transition: "box-shadow 0.15s" }}
                      onMouseOver={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"}
                      onMouseOut={e => e.currentTarget.style.boxShadow = "none"}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                        <span style={{ fontSize: 13, fontWeight: 600, flex: 1, textDecoration: task.status === "completata" ? "line-through" : "none", color: task.status === "completata" ? "#9ca3af" : "#111827" }}>
                          {task.title}
                        </span>
                        <span className={`badge badge-${task.priority}`}>{task.priority}</span>
                        <span style={{ fontSize: 11, background: statusColor[task.status] + "22", color: statusColor[task.status], padding: "2px 8px", borderRadius: 10, fontWeight: 600 }}>
                          {task.status?.replace("_", " ")}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 12, color: isOverdue ? "#dc2626" : "#6b7280", fontWeight: isOverdue ? 600 : 400 }}>
                          📅 {format(parseISO(task.dueDate), "d MMMM yyyy", { locale: it })}
                          {isOverdue && " — SCADUTA"}
                        </span>
                        {task.assignedName && <span style={{ fontSize: 12, color: "#6b7280" }}>👤 {task.assignedName}</span>}
                        {task.department && <span style={{ fontSize: 12, color: "#6b7280" }}>🏢 {task.department}</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
